import { generateInviteCodeEndpoint } from '@/config/endpoints';
import { posthogUTM, RPostHog } from '@/posthog';
import {
  UserInfoAssets,
  UserInfoContextType,
} from '@/provider/UserInfoProvider';
import { kazeFetch } from '@/utils/kazeFetch';

const { utm } = posthogUTM();
export async function generateInviteCode({
  userIdentity,
  userInfo,
}: {
  userIdentity: UserInfoContextType['userIdentity'];
  userInfo: UserInfoAssets | null;
}): Promise<{ invite_code: string } | undefined> {
  try {
    const res = await kazeFetch(generateInviteCodeEndpoint, {
      method: 'POST',
      body: JSON.stringify({}),
    });

    // 上报用户生成的邀请链接
    const generate_link = `https://kaze.ai?utm_source=referal&utm_medium=referal&utm_campaign=referal&utm_content=${res?.invite_code}`;
    RPostHog('invite_link_generated', {
      user_id: userInfo?.user_id || 'not_get_user',
      email: userInfo?.email || 'not_get_email',
      user_identity: userIdentity,
      invite_code: res?.invite_code || 'no_get_code',
      generate_link,
      ...utm,
    });

    return res;
  } catch (error) {
    throw error;
  }
}
